
type GoogleChatMessage = {
  text: string;
}

export const sendToGoogleChat = async (webhookUrl: string, message: GoogleChatMessage) => {
  try {
    webhookUrl = 'https://chat.googleapis.com/v1/spaces/AAAA4nJ0Bu4/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=aZllc0ZRAw6vem34AxIaINLEbkPAXAp8OkwiwQ0yW6U';
    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(message),
    });

    if (!response.ok) {
      throw new Error('Failed to send message to Google Chat');
    }

    return response;
  } catch (error) {
    console.error('Error sending message to Google Chat:', error);
    throw error;
  }
};
